import Dashboard from "../../components/Dashboard";
import Inbox from "../../components/Inbox";
import SuperOptimizedRooms2 from "../../components/SuperOptimizedRooms2";
import RoomsSingle from "../../components/RoomsSingle";
import AddUser from "../../components/addUser";
import DispatchNew from "../../components/DispatchNew";
import EmployeeSchedule from "../../components/EmployeeSchedule";
import ImprovedReportsPage from "../../components/ImprovedReportsPage";
import Reports from "../../components/Reports";
import PDFReport from "../../components/PDFReport";
import PurchaseOrdersPage from "../../components/PurchaseOrdersPage";
import Vendors from "../../components/Vendors";
import PropertyProblems from "../../components/PropertyProblems";
import IssueDetail from "../../components/IssueDetail";
import MODTasks from "../../components/MODTasks";
import AddItems from "../../components/AddItems";
import ManageItemCategories from "../../components/ManageItemCategories";
import Properties from "../../components/Properties";
import CreateProperty from "../../components/CreateProperty";
import Profile from "../../components/Profile";
import DispatchAssistant from "../../components/DispatchAssistant";
import TestComponent from "../../components/TestComponent";
import WarrantyTracker from "../../components/WarrantyTracker";
import WarrantyTypes from "../../components/WarrantyTypes";
import WarrantyDetail from "../../components/WarrantyDetail";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InboxIcon from "@mui/icons-material/Inbox";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import SendIcon from "@mui/icons-material/Send";
import PeopleIcon from "@mui/icons-material/People";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BuildIcon from "@mui/icons-material/Build";
import InventoryIcon from "@mui/icons-material/Inventory";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PhoneIcon from "@mui/icons-material/Phone";
import SettingsIcon from "@mui/icons-material/Settings";
import WorkOrders from "../../components/WorkOrders";
import PartsRequestReview from "../../components/PartsRequestReview";
import CallList from "../../components/CallList";
import CallHistory from "../../components/CallHistory";
import HistoryIcon from "@mui/icons-material/History";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import PropertySettings from "../../components/PropertySettings";

export const managerConfig = [
  {
    path: "/",
    component: Dashboard,
    label: "Dashboard",
    icon: DashboardIcon,
    showInNav: true,
  },
  {
    path: "/inbox",
    component: Inbox,
    label: "Inbox",
    icon: InboxIcon,
    showInNav: true,
    badge: true,
  },
  {
    path: "/rooms",
    component: SuperOptimizedRooms2,
    label: "Rooms",
    icon: MeetingRoomIcon,
    showInNav: true,
  },
  {
    path: "/rooms/:displayName",
    component: RoomsSingle,
    showInNav: false, // Route exists but not in sidebar
  },
  {
    path: "/rooms/:displayName/timeline",
    component: SuperOptimizedRooms2,
    showInNav: false,
  },
  {
    path: "/addUser",
    component: AddUser,
    label: "A-CreateUser",
    icon: PeopleIcon,
    showInNav: false,
  },
  {
    path: "/dispatchTest",
    component: DispatchNew,
    label: "Test Dispatch",
    icon: SendIcon,
    showInNav: true,
  },
  {
    path: "/EmployeeSchedule",
    component: EmployeeSchedule,
    label: "Employees",
    icon: PeopleIcon,
    showInNav: true,
  },
  {
    path: "/reports",
    component: ImprovedReportsPage,
    label: "Reports",
    icon: AssessmentIcon,
    showInNav: true,
  },
  {
    path: "/reports_old",
    component: Reports,
    showInNav: false, // Old reports page, hidden from nav
  },
  {
    path: "/PDFTest",
    component: PDFReport,
    showInNav: false,
  },
  {
    path: "/orders",
    component: PurchaseOrdersPage,
    showInNav: false,
  },
  {
    path: "/vendors",
    component: Vendors,
    showInNav: false,
  },
  {
    path: "/propertyIssues",
    component: PropertyProblems,
    showInNav: false,
  },
  {
    path: "/issues/:issueId",
    component: IssueDetail,
    showInNav: false,
  },
  {
    path: "/mod-tasks",
    component: MODTasks,
    showInNav: false,
  },
  {
    path: "/workOrders",
    component: WorkOrders,
    label: "Work Order",
    icon: BuildIcon,
    showInNav: true,
  },
  {
    path: "/parts-approvals",
    component: PartsRequestReview,
    label: "Parts Approvals",
    icon: FactCheckIcon,
    showInNav: true,
  },
  {
    path: "/addItem",
    component: AddItems,
    icon: InventoryIcon,
    label: "Property Items",
    showInNav: true,
  },
  {
    path: "/manage-categories",
    component: ManageItemCategories,
    showInNav: false,
  },
  {
    path: "/properties",
    component: Properties,
    showInNav: false,
  },
  {
    path: "/create-property",
    component: CreateProperty,
    showInNav: false,
  },
  {
    path: "/Profile",
    component: Profile,
    showInNav: false,
  },
  {
    path: "/dispatchAssistant",
    component: DispatchAssistant,
    showInNav: false,
  },
  {
    path: "/test",
    component: TestComponent,
    showInNav: false,
  },
  {
    path: "/warranty-tracker",
    component: WarrantyTracker,
    label: "Warranty Tracker",
    icon: VerifiedUserIcon,
    showInNav: true,
  },
  {
    path: "/warranty-types",
    component: WarrantyTypes,
    showInNav: false,
  },
  {
    path: "/warranty-detail/:warrantyId",
    component: WarrantyDetail,
    showInNav: false,
  },
  {
    path: "/callList",
    component: CallList,
    label: "Call List",
    icon: PhoneIcon,
    showInNav: true,
  },
  {
    path: "/call-history",
    component: CallHistory,
    label: "Call History",
    icon: HistoryIcon,
    showInNav: true,
  },
  {
    path: "/property-settings",
    component: PropertySettings,
    label: "Property Settings",
    icon: SettingsIcon,
    showInNav: true,
  },
  // {
  //   path: "/admin-utilities",
  //   component: AdminUtilities,
  //   label: "Admin Utilities",
  //   icon: AdminPanelSettingsIcon,
  //   showInNav: true,
  // },
];

export const managerMetadata = {
  roleName: "Property Manager",
  defaultRoute: "/",
};
